var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuildTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#825ECF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2819_2627",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F2A863"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2819_2627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0407,
    cy: 19.9592,
    rx: 7.95918,
    ry: 7.95918,
    fill: "#D7C6FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.7551,
    y: 24.0645,
    width: 43.3469,
    height: 10.2857,
    transform: "rotate(-63.3958 -11.7551 24.0645)",
    fill: "#D7C6FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildTransfer);
export default __webpack_public_path__ + "static/media/IconBuildTransfer.7717a96a983ed283c07ce7de0f9eb2af.svg";
export { ForwardRef as ReactComponent };